function headerScroll() {
    let windowY = window.scrollY;

    if (windowY > scrollPos) {
        // Scrolling DOWN
        //console.log("scroll-down");

        if (windowY > headerTriggerPoint) {
            header.classList.add("is-scrolled");
        }
    } else {
        // Scrolling UP
        //console.log("scroll-up");

        if (windowY < headerTriggerPoint) {
            header.classList.remove("is-scrolled");
        }
    }

    scrollPos = windowY;
}

// pratice page header

function makeSubHeaderSticky() {
    window.addEventListener("scroll", () => {
        if (window.scrollY > 
                window.innerHeight -
                header.offsetHeight -
                practiceSubHeader.offsetHeight
        ) {
            practiceSubHeader.classList.add("is-active");
        } else {
            practiceSubHeader.classList.remove("is-active");
        }
    });
}
